import React from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { authHeader } from "../../_helpers";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import config from "../../config";
import { LanguageContext } from "../../context/LanguageContext";
import {
  BarChartOutlined,
  UnorderedListOutlined,
  SearchOutlined,
  ClearOutlined,
} from "@ant-design/icons";

const styles = {
  filterRow: {
    padding: "16px",
    background: "#fff",
    borderRadius: "8px",
    border: "1px solid #f0f0f0",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    marginBottom: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  searchInput: {
    flex: "1 1 300px",
    minWidth: "250px",
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  buttonGroup: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  },
  searchButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    minWidth: "100px",
  },
  clearButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    minWidth: "100px",
  },
};

//import { UserForm } from "./userFrom";
//import { UsersListTable } from "./UsersListTable";
const UserForm = React.lazy(() =>
  import("./userFrom.js").then((module) => ({
    default: module.userFrom,
  }))
);

const UsersListTable = React.lazy(() =>
  import("./UsersListTable.js").then((module) => ({
    default: module.UsersListTable,
  }))
);

const { Option } = Select;
const FormItem = Form.Item;
let columns = [];
let data = [];
class AppUserLogin extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
  }
  state = {
    isCreateUserDrawerVisible: false,
    isUpdate: false,
    userFormEditData: [],
    resetFrom: false,
    userList: [],
    searchText: "",
    originalData: [],
  };
  userForm = React.createRef();

  componentDidUpdate() {
    // const { authentication } = this.props;
    // if(authentication && authentication.user && authentication.user.role==='2'){
    //   return <Redirect to='/login'  />
    // }
  }

  handleInputChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  componentDidMount() {
    const { user } = this.props;
    //this.props.dispatch(professionalAction.getCity());

    if (user && user.cityId && user && user.role === "4") {
      this.props.dispatch(userActions.getAppUsers(user && user.cityId));
    } else if (user && user.role === "8") {
      this.props.dispatch(userActions.getAdminUsers(4));
    }

    // plain-text string
    const str = "Base64 Encoding in Node.js";

    // create a buffer
    const buff = Buffer.from(str, "utf-8");

    // decode buffer as Base64
    const base64 = buff.toString("base64");

    // print Base64 string

    // this.props.dispatch(professionalAction.getCity());

    // if (user && user.role === "8") {
    //   // this.props.dispatch(professionalAction.getCity());
    // } else if (user && user.role === "4") {
    //   this.props.dispatch(professionalAction.getDistrict(user && user.cityId, 1));
    // }

    // Initialize originalData when component mounts
    if (this.props.users && this.props.users.appusers) {
      this.setState({ originalData: this.props.users.appusers });
    }
  }

  componentDidUpdate(prevProps) {
    // Only update originalData if users data has changed
    if (
      prevProps.users !== this.props.users &&
      this.props.users &&
      this.props.users.appusers
    ) {
      this.setState({ originalData: this.props.users.appusers });
    }
  }

  findAppUsersSearch = () => {
    const { searchText, originalData } = this.state;
    if (!originalData) return;

    let filteredData = [...originalData];
    console.log("originalData", originalData);

    if (searchText) {
      const searchStr = searchText.toLowerCase();

      filteredData = filteredData.filter((item) => {
        // Decode password first (since it's base64-encoded)
        const password = item.generalPassword
          ? Buffer.from(item.generalPassword, "base64")
              .toString("utf-8")
              .toLowerCase()
          : "";

        return (
          (item.firstName &&
            item.firstName.toLowerCase().includes(searchStr)) ||
          (item.lastName && item.lastName.toLowerCase().includes(searchStr)) ||
          (item.districtName &&
            item.districtName.toLowerCase().includes(searchStr)) ||
          (item.phone && item.phone.toLowerCase().includes(searchStr)) ||
          password.includes(searchStr) // password search
        );
      });
    }

    let dataSource = filteredData.map((item, index) => {
      let temppass = item.generalPassword
        ? Buffer.from(item.generalPassword, "base64").toString("utf-8")
        : "N/A";

      return {
        ...item,
        "Sr.No": index + 1,
        password: temppass,
        Name: item.firstName + " " + item.lastName,
        status:
          parseInt(item.status) === 0
            ? "Pending"
            : parseInt(item.status) === 1
            ? "Approved"
            : parseInt(item.status) === 2
            ? "Rejected"
            : "",
      };
    });

    this.setState({ data: dataSource });
  };

  clearFilter = () => {
    this.setState(
      {
        searchText: "",
        data: this.state.originalData || [],
      },
      () => {
        this.findAppUsersSearch();
      }
    );
  };

  onOpenCrateUserDrawer = () => {
    this.setState({
      isCreateUserDrawerVisible: true,
      resetFrom: true,
      isUpdate: false,
    });
  };
  onCloseCrateUserDrawer = () => {
    this.setState({
      isCreateUserDrawerVisible: false,
      resetFrom: false,
      isUpdate: false,
    });
  };

  //   onCityChange = (cityid) =>{
  //     const { user } = this.props;
  //     if (user && user.cityId && user && user.role ==='4') {
  //       this.props.dispatch(userActions.getAll(cityid, 2));
  //     }
  //   }
  // shouldComponentUpdate(nextProps, nextState) {

  //     // if(this.props && this.props.users && this.props.users.error === nextProps && nextProps.users && nextProps.users.error){
  //     //     message.error('Mobile Number Already used')
  //     // }
  //   return false;
  // }

  onFormFinish = (values) => {
    const { user, users, professionals } = this.props;
  };
  onFormUpdate = (values) => {
    const { id, districtName, cityName } = this.state.userFormEditData;
    let updatedObject = {
      ...values,
      districtName,
      cityName,
    };
    if (values) {
      this.props.dispatch(userActions.updateAppUser(updatedObject, id));
      message.success("Update Status Successfully !!!");
    }
    this.setState((prevState) => ({
      isCreateUserDrawerVisible: false,
      userFormEditData: [],
      isUpdate: false,
    }));
  };
  getDistrictName = (id) => {
    const { basicDistricts } = this.props;
    if (basicDistricts && basicDistricts.length) {
      return (
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0].DistrictName
      );
    }
  };
  getCityName = (id) => {
    const { pc_cities } = this.props;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  onEdituser = async (data) => {
    const { user } = this.props;
    console.log("data",data)
    if (data) {
      const { id, currentIndex } = data;
      let updatedObject = {
        ...data,
        status: currentIndex,
      };
      this.props.dispatch(userActions.updateAppUser(updatedObject, id));
      if (data.status === "Pending") {
        let message = "";
        message += "Thanks for CMIS APP Registration. \n\n";
        message += `USER ID: ${data.phone} \n\n`;
        message += `PASSWORD: ${data.password} \n\n`;
        message += "CMIS TEAM \n\n";
        message += `${data.cityName}`;
        const baseUrl = config.apiGateway.baseUrl;
        const postData = {
          phone: data.phone,
          password: data.password,
          cityName: data.cityName,
        };
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...authHeader(),
          },
          body: JSON.stringify(postData),
        };
        const res = await fetch(
          baseUrl + "/criminal/whatsappclient",
          requestOptions
        )
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
          });
      }
      message.success("Update Status Successfully !!!");
      window.location.reload();
      if (user && user.cityId && user && user.role === "4") {
        this.props.dispatch(userActions.getAppUsers(user && user.cityId));
      } else if (user && user.role === "8") {
        this.props.dispatch(userActions.getAdminUsers(4));
      }
      
    }
  };

  handleResponse = (response) => {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      //logout();
      // location.reload(true);
    }

    return response.text().then((text) => {
      const data = text && JSON.parse(text);
      if (!response.ok) {
        if (response.status === 401) {
          // auto logout if 401 response returned from api
          // location.reload(true);
        }
        if (response.status === 404) {
          //message.error(response.statusText)
        }
        if (response.status === 400) {
          message.error(response.statusText);
        }
        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }

      return data;
    });
  };

  onUserFormSave = () => {
    this.userForm.current.onFinish(true);
  };
  onUserFormUpdate = () => {
    this.userForm.current.onFinish(false);
  };
  // this.decryptAES(itemObj.generalPassword, "password_1234")
  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { pc_cities, basicDistricts } = this.props;
    const { language, t } = this.context;

    const requiredKeys = [
      "Sr.No",
      "name",
      "cityName",
      "districtName",
      "phone",
      "password",
    ];
    const requiredKeysTitle = [
      t("sr.no"),
      t("name"),
      t("unit"),
      t("police_station"),
      t("phone"),
      t("password"),
    ];
    if (users && users.appusers && users.appusers.length > 0) {
      let columns1 = users.appusers.map((itemObj, index) => {
        const temppass = itemObj.generalPassword
          ? Buffer.from(itemObj.generalPassword, "base64")
          : null;

        return {
          ...itemObj,
          key: index + 1,
          password: temppass ? temppass.toString("utf-8") : "N/A",
        };
      });

      let tablelabes = columns1 && Object.keys(columns1[0]);

      let tableColumns = [];
      tablelabes.forEach((item) => {
        if (
          _.filter(requiredKeys, function (o) {
            return o === item;
          }).length
        ) {
          tableColumns.push(item);
        }
      });

      tableColumns && tableColumns.unshift("Name");
      tableColumns && tableColumns.unshift("Sr.No");
      let columnList = tableColumns.map((item, index) => {
        return {
          title: requiredKeysTitle[index],
          dataIndex: item,
          key: item,
        };
      });

      columns1 &&
        columns1.map((item) => {
          item.status =
            parseInt(item.status) === 0
              ? "Pending"
              : parseInt(item.status) === 1
              ? "Approved"
              : parseInt(item.status) === 2
              ? "Rejected"
              : "";
        });
      columns1.reverse();
      let dataSoruce = columns1.map((item, index) => {
        return {
          ...item,
          "Sr.No": index + 1,
          Name: item.firstName + " " + item.lastName,
        };
      });

      // Use state data if available, otherwise use the processed data
      data = this.state.data || dataSoruce;
      columns = columnList;
    } else {
      data = [];
      columns = [];
    }
    const roleFour = user && user.role === "4" ? "घटक" : "जिल्हा";
    return (
      <div className="col-md-6 col-md-offset-3">
        <div className="site-page-header-ghost-wrapper">
          <PageHeader
            ghost={false}
            onBack={false}
            // title={user && user.userid}
            title={t("app_used")}
          >
            <Descriptions size="small" column={3}>
              <Descriptions.Item
              // label={user && user.role === "8" ? "राज्य" : roleFour}
              >
                {/* {user && user.role === "8"
                  ? "महाराष्ट्र"
                  : "महाराष्ट्र" +
                    " " +
                    "( " +
                    this.getCityName(user && user.cityId) +
                    " )"} */}
              </Descriptions.Item>
            </Descriptions>
          </PageHeader>
        </div>
        <div className="filter-row" style={styles.filterRow}>
          <div className="search-filter">
            <div style={styles.searchInput}>
              <Input
                placeholder="Search..."
                value={this.state.searchText}
                onChange={this.handleInputChange}
                prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                style={{ flex: "1", borderRadius: "6px", width: "50%" }}
                disabled={data == 0}
                allowClear
              />
              <div style={styles.buttonGroup}>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  className="modern-button modern-button-success"
                  disabled={data == 0}
                  onClick={this.findAppUsersSearch}
                >
                  {t("search")}
                </Button>
                {this.state.searchText && (
                  <Button
                    onClick={(e) => {
                      this.clearFilter();
                    }}
                    className="modern-button modern-button-danger"
                  >
                    {t("clear")}
                  </Button>
                )}
              </div>
            </div>
            <div
              style={{
                padding: "4px 12px",
                background: "#fff",
                borderRadius: "4px",
                border: "1px solid #d9d9d9",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span style={{ color: "#666" }}>{t("total")}:</span>
              <span style={{ fontWeight: "bold" }}>{data.length}</span>
            </div>
          </div>
        </div>

        <Divider />
        <Drawer
          title="अ‍ॅप वापरकर्ता"
          placement="right"
          width={720}
          closable={true}
          onClose={this.onCloseCrateUserDrawer}
          visible={this.state.isCreateUserDrawerVisible}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Button
                onClick={this.onCloseCrateUserDrawer}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
              {!this.state.isUpdate ? (
                <Button onClick={this.onUserFormSave} type="primary">
                  Save
                </Button>
              ) : (
                <Button onClick={this.onUserFormUpdate} type="primary">
                  Update
                </Button>
              )}
            </div>
          }
        >
          <React.Suspense fallback={<div>Loading userform...</div>}>
            <UserForm
              ref={this.userForm}
              user={user}
              cityData={pc_cities}
              isUpdate={this.state.isUpdate}
              districtData={basicDistricts}
              users={users}
              onFormFinish={this.onFormFinish}
              onFormUpdate={this.onFormUpdate}
              userFormEditData={this.state.userFormEditData}
              resetFrom={this.state.resetFrom}
            ></UserForm>
          </React.Suspense>
        </Drawer>
        <React.Suspense fallback={<div>Loading...</div>}>
          <UsersListTable
            onEdituser={this.onEdituser}
            data={data}
            columns={columns}
            userRole={user}
          ></UsersListTable>
        </React.Suspense>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const { pc_cities, basicDistricts } = professionals;
  return {
    user,
    users,
    pc_cities,
    basicDistricts,
  };
}

const connectedAppUserLogin = connect(mapStateToProps)(AppUserLogin);
export { connectedAppUserLogin as AppUserLogin };
